import {Component, inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {ImportField} from "../import.service";
import {SelectFieldTypeDialogData} from "../../../../core/definitions/select-field-type-dialog.data";

@Component({
    selector: 'app-select-field-dialog',
    templateUrl: './select-field-dialog.component.html',
    styleUrls: ['./select-field-dialog.component.scss'],
    standalone: false
})
export class SelectFieldDialogComponent {
  // Injections
  public data: SelectFieldTypeDialogData = inject(MAT_DIALOG_DATA);
  public dialogRef: MatDialogRef<SelectFieldDialogComponent> = inject(MatDialogRef);

  selectedField: ImportField;

  onNoClick(): void {
    this.dialogRef.close();
  }

}
